import i18n from "@/i18n";
import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '교육일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['교육일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.교육일', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.교육일', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "교육일",
        "key": "body.교육일"
      },
      {
        "name": "교육장소",
        "key": "body.교육장소"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name // 회사명
        case 1:
          return func.getContent(value).교육일 // 교육일
        case 2:
          return func.getContent(value).교육장소 // 교육장소
        case 3:
          return func.getContent(value).stdInfo.department // 소속명
        case 4:
          return func.getContent(value).stdInfo.section // 부서명
        case 5:
          return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  // =================================================================================================================
  // 엑셀 다운로드 설정 (목록형 단일 시트 - 템플릿 파일 없이 코드에서 직접 생성)
  //  - 1행 헤더, 2행부터 "문서 1건당 1행"으로 채운다.
  //  컬럼: A 구분(빈값) / B 부서명(com_name) / C 교육일 / D 교육시간 / E 교육장소 / F 교육내용 /
  //        G~ 참석자 성명(가로로 나열)
  excelInfo: (dataList) => {
    const HEADER = ["구분", "부서명", "교육일", "교육시간", "교육장소", "교육내용", "참석자 명단"];
    const ATTENDEE_START_COL = 7; // 참석자 명단 시작 열 (G)
    return {
      downloadFileName: "위험성평가 교육 결과(실시 전)",
      worksheetName: () => "위험성평가 교육 결과(실시 전)",
      singleSheet: (worksheet, posts) => {
        // 헤더 (1행)
        HEADER.forEach((h, ci) => {
          worksheet.getRow(1).getCell(ci + 1).value = h;
        });

        // 데이터 (2행부터)
        posts.forEach((post, i) => {
          let body = {};
          try {
            body = JSON.parse(post.post_content).body || {};
          } catch (e) { /* ignore */ }
          const std = body.stdInfo || {};

          // 교육시간: { sTime, eTime } → "sTime ~ eTime"
          const t = body.교육시간 || {};
          const timeStr = t.sTime || t.eTime ? `${t.sTime || ""} ~ ${t.eTime || ""}` : "";

          // 참석자 성명 목록
          const names = Array.isArray(body.참석자명단)
            ? body.참석자명단.map((a) => (a && a.성명 ? a.성명 : "")).filter((n) => n !== "")
            : [];

          const row = worksheet.getRow(2 + i);
          row.getCell(1).value = ""; // A 구분 (빈값)
          row.getCell(2).value = std.com_name || ""; // B 부서명
          row.getCell(3).value = body.교육일 || ""; // C 교육일
          row.getCell(4).value = timeStr; // D 교육시간
          row.getCell(5).value = body.교육장소 || ""; // E 교육장소
          row.getCell(6).value = body.교육내용 || ""; // F 교육내용
          names.forEach((name, ni) => {
            row.getCell(ATTENDEE_START_COL + ni).value = name; // G, H, I ...
          });
        });
      },
    };
  },

  // 전체 다운로드(모든 문서 엑셀다운로드) - 새 워크북에 목록형으로 채운 뒤 다운로드
  customExcelDownload: async (dataList, title) => {
    const excelInfo = list.excelInfo(dataList);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelInfo.worksheetName ? excelInfo.worksheetName() : "Sheet1");
    excelInfo.singleSheet(worksheet, dataList);
    await excelSupporter.workbookDownload(workbook, excelInfo.downloadFileName);
  },
}

export default list;
